import React, { Component } from 'react';
import { firebase } from '../../../config/firebase'

import { Card, CardBody, CardFooter, Col, Input, Label, FormGroup,} from 'reactstrap';
import { Button } from 'semantic-ui-react'
import 'semantic-ui-css/semantic.min.css'

function capital_varter(str) {
  // str = str.split(" ");

  // for (var i = 0, x = str.length; i < x; i++) {
  //   str[i] = str[i][0].toUpperCase() + str[i].substr(1);
  // }

  return str.trim().toLowerCase()
}

function createNewUser(name, email, password) {
  var er_detect = 0;
  // return er_detect ;
  firebase.auth().createUserWithEmailAndPassword(
    email, password).then(() => {
      var user = firebase.auth().currentUser;
      user.updateProfile({
        displayName: name,
      })
    }).catch(function (error) {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
      er_detect = 0;
      if (errorCode === 'auth/weak-password') {
        er_detect = 1;
        alert('The password is too weak.');
      } else {
        er_detect = 1;
        alert(errorMessage);
      }
      console.log(error);
    }).then(function (sendEmailVerify) {
      // alert(er_detect);
      if (er_detect === 0) {
        // Error is not detected.
        firebase.auth().currentUser.sendEmailVerification().then(() => {
          firebase.auth().signOut()
        })
        alert('Email Verification Sent! Please check your email (It may be in your spam or junk mail).');
        alert('Register Success');
        // save(customer);
      } else if (er_detect === 1) {
        // location.reload(forceGet);
      }
    });
  return er_detect
}

function save(customer, id) {
  return firebase.database().ref("User").child(id).set(customer)
    .then(() => {
      return Promise.resolve(customer);
    }).then(() => {
      console.log('Write succeeded!');
    })
}

function Check_HosInfo(HosName,Province,Region){
  let ref = firebase.database().ref("Hospital_information").child(HosName);
  ref.once("value")
  .then(async function (snapshot) {
    let a = snapshot.exists();
    if (a === false) {
      var OccSet = {
        IsMedIns:false,
        IsDoc:false,
        IsMedStu:false,
        IsNurIns:false,
        IsNur:false,
        IsNurStu:false,
        IsPracNur:false,
        IsPhyThera:false,
        IsXRay:false,
        IsOther:false,
    };
    const add_val = {"Occupation":OccSet,
    "Province":Province,
    "Region":Region}
    await ref.set(add_val)
  }

  })
  
}

class Register extends Component {
  constructor() {
    super();
    this.state = {
      isLoading: false,
      username: "", //id,
      firstname: "", //firstname
      surname: "", //surname
      email: "", //email
      password: "", //password
      Hospital: "", //hospital
      Gender: "", //Gender
      Occupation: "", //Occupation
      Region: "Central", //Region
      Province: "Bangkok", //Province
      train_by: "", //train_by
      train_date: "", //train_date
      train_pass :'no',
      train_score : 0,
      train_time : 0,
      AdminOption: '',
      Is_pdpa : false,
      TrainedOption: ''
    }
  }
  // async componentDidMount() {
  //   this.setState({ isLoading: true })
  // }

  OnChangeFirstName = (e) => {
    this.setState({ firstname: capital_varter(e.target.value) });
  }

  OnChangeSurName = (e) => {
    this.setState({ surname: capital_varter(e.target.value) });
  }

  OnChangeEmail = (e) => {
    this.setState({ email: e.target.value });
  }

  OnChangeUsrName = (e) => {
    this.setState({ username: e.target.value });
  }

  OnChangePassword = (e) => {
    this.setState({ password: e.target.value.trim() });
  }


  radioChange2 = (e) => {
    this.setState({
      TrainedOption: e.currentTarget.value
    });
    // alert(e.currentTarget.value)
  }

  onProvChange = (e) => {
    this.setState({
      Province: e.target.value
    })
    let Region =""
    if (e.target.value ==="ChiangMai"||e.target.value ==="ChiangRai"||e.target.value ==="Lampang"
    ||e.target.value ==="Lamphun"||e.target.value ==="MaeHongSon"||e.target.value ==="Nan"
    ||e.target.value ==="Phayao"||e.target.value ==="Phrae"||e.target.value ==="Uttaradit"){
      Region = 'Northern'
    } else if (e.target.value ==="BuengKan"||e.target.value ==="AmnatCharoen"||
    e.target.value ==="Buriram"||e.target.value ==="Chaiyaphum"||e.target.value ==="Kalasin"||e.target.value ==="KhonKaen"||
    e.target.value ==="MahaSarakham"||e.target.value ==="Mukdahan"||e.target.value ==="NakhonPhanom"||e.target.value ==="NakhonRatchasima"||
    e.target.value ==="NakhonSiThammarat"||e.target.value ==="NongBuaLamPhu"||e.target.value ==="NongKhai"||e.target.value ==="RoiEt"||
    e.target.value ==="SaKaeo"||e.target.value ==="SakonNakhon"||e.target.value ==="Sisaket"||e.target.value ==="Surin"||
    e.target.value ==="UbonRatchathani"||e.target.value ==="UdonThani"||e.target.value ==="Yasothon"){
      Region = "NorthEastern"
    } else if (e.target.value ==="Phetchaburi"||e.target.value ==="Kanchanaburi"||e.target.value ==="PrachuapKhiriKhan"
    ||e.target.value ==="Tak"||e.target.value ==="Ratchaburi"){
      Region = "Western"
    } else if (e.target.value ==="Chachoengsao"||e.target.value ==="Chanthaburi"||e.target.value ==="Chonburi"
    ||e.target.value ==="Prachinburi"||e.target.value ==="Rayong"||e.target.value ==="Trat"){
      Region = "Eastern"
    } else if (e.target.value ==="Chumphon"||e.target.value ==="Krabi"||e.target.value ==="Narathiwat"
    ||e.target.value ==="Pattani"||e.target.value ==="PhangNga"||e.target.value ==="Phatthalung"
    ||e.target.value ==="Phuket"
    ||e.target.value ==="Ranong"||e.target.value ==="Satun"||e.target.value ==="Songkhla"
    ||e.target.value ==="SuratThani"||e.target.value ==="Trang"||e.target.value ==="Yala"){
      Region = "Southern"
    } else{
      Region = "Central"
    }
    this.setState({
      Region : Region
    })

  }

  onRegChange = (e) => {
    this.setState({
      Region: e.target.value
    })
    // alert(e.target.value)
  }

  onGenderChange = (e) => {
    this.setState({
      Gender: e.target.value
    })
    // alert(e.target.value)
  }

  OnChangeOccupation = (e) => {
    this.setState({ Occupation: e.target.value });
  }

  OnChangeAffiliation = (e) => {
    this.setState({ Hospital: capital_varter(e.target.value)});
    // alert(e.target.value)
  }

  OnChangeTrainBy = (e) => {
    this.setState({ train_by: e.target.value });
    // alert(e.target.value)
  }

  OnChangeTraindate = (e) => {
    this.setState({ train_date: e.target.value });
    // alert(e.target.value)
  }

  SubmitClick = async () => {
    this.setState({ isLoading: true })
    var err_det = 0
    try {
      var firstname = window.btoa(this.state.firstname)
    } catch (err) {
      err_det = 1
      alert('Please Enter Your First Name');
    }
    
    try {
      var surname = window.btoa(this.state.surname)
    } catch (err) {
      err_det = 1
      alert('Please Enter Your Surname');
    }
    try {
      var hospital = this.state.Hospital
      if (this.state.Hospital ===""){
        alert('Please Enter Your Hospital Name in an Affiliation')
        err_det = 1
      } else if (this.state.Hospital ==="ramathibodi"){
        this.setState({ Hospital: 'ramathibodi2' });
        hospital = 'ramathibodi2'
      }

    } catch (err) {
      err_det = 1
      alert('Please Enter Your Hospital Name');
    }
    var train_by
    try {
      train_by = this.state.train_by
    } catch (err) {
      train_by = "";
    }
    var train_date
    try {
      train_date = this.state.train_date
    } catch (err) {
      train_date = "";
    }
    try {
      var id = this.state.username
      console.log(id)
    } catch (err) {
      err_det = 1
      alert('Please Enter Your User Name');
    }

    var email = this.state.email
    var password = window.btoa(this.state.password)
    var uncodePassword = this.state.password
    var Gender = this.state.Gender !== '' ? this.state.Gender : 'Male'
    var Occupation = this.state.Occupation
    var Region = this.state.Region
    var Province = this.state.Province

    if (Region===""){
      Region = 'Northern'
    }else if (Region==="Region"){
      Region = 'Central'
    }

    if (Province ===""){
      Province = 'Bangkok'
    }

    var customer = {
      username: id,
      firstname: firstname,
      surname: surname,
      email: email,
      password: password,
      Hospital: hospital,
      Gender: Gender,
      Occupation: Occupation,
      Region: Region,
      Province: Province,
      Visits: 0,
      Record: 0,
      Record_season: "",
      train_by: train_by,
      train_date: train_date,
      AdminOption: this.state.AdminOption,
      Is_pdpa : false,
      train_score: 0,
      train_time: 0,
      train_pass: 'no'
    };

    if (id.length !== 0 && password.length !== 0 && email.length !== 0) {
      var firebaseRef = firebase.database().ref()
      var snapshot = await firebase.database().ref('User/' + id).once("value")
      if (snapshot) {
        let a = await snapshot.exists()
        if (!a) {

          await createNewUser(id, email, uncodePassword)
          await save(customer, id)
          await Check_HosInfo(hospital,Province,Region)
          await this.props.history.replace('/login')

        } else {
          alert("Please Change your username, it alreay existed.")
        }
      }
    }else {
      alert("Register Not Succuess. Please Check your information.")
    }

    this.setState({ isLoading: false })

  }



  render() {
    return (
      <div className=" app align-items-center">

        <div className="container align-items-center" >
          <h1 className='text-center mt-2'>Register</h1>
          <div   style={{ justifyContent: 'center', alignItems: 'center' }}>
            <div className="col-xs-12">
              <Card>
                <CardBody>
                  <div className="row" style={{ marginTop: 20 }}>
                    <Col md="6">
                      <div className="row">
                        <Col xs="12" md="3">
                          <Label htmlFor="text-input" style={{ textAlign: 'center', marginTop: 5 }}>First Name</Label>
                        </Col>
                        <Col xs="12" md="9">
                          <Input value={this.state.firstname} onChange={this.OnChangeFirstName} style={{ marginLeft: 0 }} type="text" id="text-input" name="text-input" placeholder="Enter your First name" />
                        </Col>
                      </div>
                    </Col>

                    <Col md="6">
                      <div className="row">
                        <Col xs="12" md="3">
                          <Label htmlFor="text-input" style={{ textAlign: 'center', marginTop: 5 }}>SurName</Label>
                        </Col>
                        <Col xs="12" md="9">
                          <Input value={this.state.surname} onChange={this.OnChangeSurName} style={{ marginLeft: 0 }} type="text" id="text-input" name="text-input" placeholder="Enter your SurName" />
                        </Col>
                      </div>
                    </Col>
                  </div>
                  
                  <div className="row" style={{ marginTop: 20 }}>
                    <Col md="6">
                      <div className="row">
                        <Col xs="12" md="3">
                          <Label htmlFor="text-input" style={{ textAlign: 'center', marginTop: 5 }}>UserName</Label>
                        </Col>
                        <Col xs="12" md="9">
                          <Input value={this.state.username} onChange={this.OnChangeUsrName} style={{ marginLeft: 0 }} type="text" id="text-input" name="text-input" placeholder="Enter your User name" />
                        </Col>
                      </div>
                    </Col>

                    <Col md="6">
                      <div className="row">
                        <Col xs="12" md="3">
                          <Label htmlFor="text-input" style={{ textAlign: 'center', marginTop: 5 }}>Email</Label>
                        </Col>
                        <Col xs="12" md="9">
                          <Input value={this.state.email} onChange={this.OnChangeEmail} style={{ marginLeft: 0 }} Input type="email" id="email-input" name="email-input" placeholder="Enter your Email" autoCompvare="email" />
                        </Col>
                      </div>
                    </Col>
                  </div>
                  
                  <div className="row" style={{ marginTop: 20 }}>

                    <Col md="6">
                      <div className="row">
                        <Col xs="12" md="3">
                          <Label htmlFor="text-input" style={{ textAlign: 'center', marginTop: 5 }}>Password</Label>
                        </Col>
                        <Col xs="12" md="9">
                          <Input value={this.state.password} onChange={this.OnChangePassword} style={{ marginLeft: 0 }} type="password" id="password-input" name="password-input" placeholder="Password" autoCompvare="new-password" />
                        </Col>
                      </div>
                    </Col>

                  </div>
                  
                  <div className="row" style={{ marginTop: 20 }}>

                    <Col md="6">
                      <div className="row">
                        <Col xs="12" md="3">
                          <Label htmlFor="text-input" style={{ textAlign: 'center', marginTop: 5 }}>Gender</Label>
                        </Col>
                        <Col xs="12" md="9">
                          <Input onChange={this.onGenderChange} type="select" name="selectSm" id="SelectLm" bsSize="md">
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                          </Input>
                        </Col>
                      </div>
                    </Col>

                    <Col md="6">
                    </Col>
                  </div>
                  
                  <div className="row" style={{ marginTop: 20 }}>
                    <Col md="6">
                      <div className="row">
                        <Col xs="12" md="3">
                          <Label htmlFor="text-input" style={{ textAlign: 'center', marginTop: 5 }}>Position</Label>
                        </Col>
                        <Col xs="12" md="9">
                          <Input value={this.state.Occupation} 
                          onChange={this.OnChangeOccupation} 
                          style={{ marginLeft: 0 }} type="text" 
                          id="text-input" 
                          name="text-input" 
                          placeholder="Enter your Position, e.g., Nurse" 
                          />
                        </Col>
                      </div>
                    </Col>

                    <Col md="6">
                      <div className="row">
                        <Col xs="12" md="3">
                          <Label htmlFor="text-input" style={{ textAlign: 'center', marginTop: 5 }}>Hospital</Label>
                        </Col>
                        <Col xs="12" md="9">
                          <Input value={this.state.Hospital} onChange={this.OnChangeAffiliation} style={{ marginLeft: 0 }} 
                          type="text" id="text-input" 
                          name="text-input" 
                          placeholder="Enter your Hospital name e.g., ramathibodi" 
                          />
                        </Col>
                      </div>
                    </Col>
                  </div>
                  
                  <div className="row" style={{ marginTop: 20 }}>
                    <Col md="6">
                      <div className="row">
                        <Col xs="12" md="3">
                          <Label htmlFor="text-input" style={{ textAlign: 'center', marginTop: 5 }}>Province</Label>
                        </Col>
                        <Col xs="12" md="9">
                          <Input onChange={this.onProvChange} type="select" name="selectSm" id="SelectLm" bsSize="md">
                            <option value="Bangkok">Bangkok</option>
                            <option value="AmnatCharoen">AmnatCharoen</option>
                            <option value="AngThong">AngThong</option>
                            <option value="BuengKan">BuengKan</option>
                            <option value="Buriram">Buriram</option>
                            <option value="Chachoengsao">Chachoengsao</option>
                            <option value="ChaiNat">ChaiNat</option>
                            <option value="Chaiyaphum">Chaiyaphum</option>
                            <option value="Chanthaburi">Chanthaburi</option>
                            <option value="ChiangMai">ChiangMai</option>
                            <option value="ChiangRai">ChiangRai</option>
                            <option value="Chonburi">Chonburi</option>
                            <option value="Chumphon">Chumphon</option>
                            <option value="Kalasin">Kalasin</option>
                            <option value="KamphaengPhet">KamphaengPhet</option>
                            <option value="Kanchanaburi">Kanchanaburi</option>
                            <option value="KhonKaen">KhonKaen</option>
                            <option value="Krabi">Krabi</option>
                            <option value="Lampang">Lampang</option>
                            <option value="Lamphun">Lamphun</option>
                            <option value="Loei">Loei</option>
                            <option value="Lopburi">Lopburi</option>
                            <option value="MaeHongSon">MaeHongSon</option>
                            <option value="MahaSarakham">MahaSarakham</option>
                            <option value="Mukdahan">Mukdahan</option>
                            <option value="NakhonNayok">NakhonNayok</option>
                            <option value="NakhonPathom">NakhonPathom</option>
                            <option value="NakhonPhanom">NakhonPhanom</option>
                            <option value="NakhonRatchasima">NakhonRatchasima</option>
                            <option value="NakhonSawan">NakhonSawan</option>
                            <option value="NakhonSiThammarat">NakhonSiThammarat</option>
                            <option value="Nan">Nan</option>
                            <option value="Narathiwat">Narathiwat</option>
                            <option value="NongBuaLamPhu">NongBuaLamPhu</option>
                            <option value="NongKhai">NongKhai</option>
                            <option value="Nonthaburi">Nonthaburi</option>
                            <option value="PathumThani">PathumThani</option>
                            <option value="Pattani">Pattani</option>
                            <option value="PhangNga">PhangNga</option>
                            <option value="Phatthalung">Phatthalung</option>
                            <option value="Phayao">Phayao</option>
                            <option value="Phetchabun">Phetchabun</option>
                            <option value="Phetchaburi">Phetchaburi</option>
                            <option value="Phichit">Phichit</option>
                            <option value="Phitsanulok">Phitsanulok</option>
                            <option value="Ayutthaya">Ayutthaya</option>
                            <option value="Phrae">Phrae</option>
                            <option value="Phuket">Phuket</option>
                            <option value="Prachinburi">Prachinburi</option>
                            <option value="PrachuapKhiriKhan">PrachuapKhiriKhan</option>
                            <option value="Ranong">Ranong</option>
                            <option value="Ratchaburi">Ratchaburi</option>
                            <option value="Rayong">Rayong</option>
                            <option value="RoiEt">RoiEt</option>
                            <option value="SaKaeo">SaKaeo</option>
                            <option value="SakonNakhon">SakonNakhon</option>
                            <option value="SamutPrakan">SamutPrakan</option>
                            <option value="SamutSakhon">SamutSakhon</option>
                            <option value="SamutSongkhram">SamutSongkhram</option>
                            <option value="Saraburi">Saraburi</option>
                            <option value="Satun">Satun</option>
                            <option value="SingBuri">SingBuri</option>
                            <option value="Sisaket">Sisaket</option>
                            <option value="Songkhla">Songkhla</option>
                            <option value="Sukhothai">Sukhothai</option>
                            <option value="SuphanBuri">SuphanBuri</option>
                            <option value="SuratThani">SuratThani</option>
                            <option value="Surin">Surin</option>
                            <option value="Tak">Tak</option>
                            <option value="Trang">Trang</option>
                            <option value="Trat">Trat</option>
                            <option value="UbonRatchathani">UbonRatchathani</option>
                            <option value="UdonThani">UdonThani</option>
                            <option value="UthaiThani">UthaiThani</option>
                            <option value="Uttaradit">Uttaradit</option>
                            <option value="Yala">Yala</option>
                            <option value="Yasothon">Yasothon</option>
                          </Input>
                        </Col>
                      </div>
                    </Col>

                    <Col md="6">

                    <div className="row">
                        <Col xs="12" md="3">
                          <Label htmlFor="text-input" style={{ textAlign: 'center', marginTop: 5 }}>Region</Label>
                        </Col>
                        <Col xs="12" md="9">
                        <Label htmlFor="text-input" style={{ textAlign: 'center', marginTop: 7 }}>{this.state.Region}</Label>
                        </Col>
                      </div>
                    </Col>
                  </div>

                  
                  <div className="row" style={{ marginTop: 20 }}>
                    <label style={{ marginLeft: 10 }}>Have you ever taken the hand Hygiene Audit training course?</label>
                    <Col md="4">
                      <div className="row">
                        <Col xs="12" md="9" style={{ textAlign: 'center', marginTop: 5 }}>
                          <FormGroup check inline>
                            <Input className="form-check-input" type="radio" id="inline-radio1" name="inline-radios"
                              value="Yes" checked={this.state.TrainedOption === "Yes"}
                              onChange={this.radioChange2} />
                            <Label className="form-check-label" check htmlFor="inline-radio1">Yes</Label>
                          </FormGroup>
                          <FormGroup check inline>
                            <Input className="form-check-input" type="radio" id="inline-radio2" name="inline-radios"
                              value="No" checked={this.state.TrainedOption === "No"}
                              onChange={this.radioChange2} />
                            <Label className="form-check-label" check htmlFor="inline-radio2">No</Label>
                          </FormGroup>
                        </Col>
                      </div>
                    </Col>
                  </div>

                  
                  <div className="row" style={{ marginTop: 10 }}>
                    <Col md="6">
                      <div className="row">
                        <Col xs="12" md="3">
                          <Label htmlFor="text-input" style={{ textAlign: 'center', marginTop: 5 }}>By</Label>
                        </Col>
                        <Col xs="12" md="9">
                          <Input value={this.state.train_by} onChange={this.OnChangeTrainBy} style={{ marginLeft: 0 }} type="text" id="text-input" name="text-input" placeholder=" E.g. Ramathibodi Hospital" />
                        </Col>
                      </div>
                    </Col>

                    <Col md="6">
                      <div className="row">
                        <Col xs="12" md="3">
                          <Label htmlFor="text-input" style={{ textAlign: 'center', marginTop: 5 }}>On</Label>
                        </Col>
                        <Col xs="12" md="9">
                          <Input value={this.state.train_date} onChange={this.OnChangeTraindate} style={{ marginLeft: 0 }} type="text" id="text-input" name="text-input" placeholder="dd/mm/yyyy" />
                        </Col>
                      </div>
                    </Col>
                  </div>


                </CardBody>
                <CardFooter>
                  <Button loading={this.state.isLoading} onClick={this.SubmitClick} type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>&nbsp;
                </CardFooter>
              </Card>
            </div>
          </div>

        </div>


      </div>
    );
  }
}

export default Register;



// WEBPACK FOOTER //
// ./src/views/Pages/Register/Register.js